import { render } from "./AlienPlayerScoutReportForm.vue?vue&type=template&id=611352af"
import script from "./AlienPlayerScoutReportForm.vue?vue&type=script&lang=js"
export * from "./AlienPlayerScoutReportForm.vue?vue&type=script&lang=js"

import "./AlienPlayerScoutReportForm.vue?vue&type=style&index=0&id=611352af&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__